import { CHECK_IN_MODE_KEY } from '../check-in-mode.service';

/** How long after its end a saved event stops being resumed on its own. */
export const AUTO_RESUME_GRACE_MS = 24 * 60 * 60 * 1000;

/**
 * Whether a saved event ended so long ago that resuming it can only be refused.
 *
 * The API refuses the PIN once the event's toDate has passed, and charges every
 * refusal to the venue IP's failed-PIN budget (10 per 10 minutes, shared by every
 * door at the venue). A phone still holding last week's event must not spend that
 * budget on each launch, nor strand itself on that event's PIN screen once it runs
 * out. The day of grace absorbs any timezone skew in toDate, and a date that does
 * not parse answers false, so a live event is never skipped by mistake.
 */
export function endedLongAgo(toDate: string | undefined, now: number): boolean {
  const end = toDate ? Date.parse(toDate) : NaN;
  return Number.isFinite(end) && now > end + AUTO_RESUME_GRACE_MS;
}

/**
 * Forget the saved session: the event, its PIN and token, and the group and
 * check-in/check-out mode picked in it, so Home has nothing left to resume. For
 * leaving an event (Settings > Change event) and for a resume the server refuses.
 */
export function clearSavedSession(): void {
  for (const key of [
    'RGCheckInToken',
    'RGCheckInPIN',
    'RGCheckInEvent',
    'RGCheckInSelectedCluster',
    'RGCheckInSelectedClusterEvent',
    CHECK_IN_MODE_KEY,
  ]) {
    localStorage.removeItem(key);
  }
}
